import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMergeRefs } from '@floating-ui/react';
import { useStyles } from '../../../hooks/useStyles';
import { NavigationRail, } from '../../../components/NavigationRail';
import { FloatingTransition } from '../../../components/FloatingTransition';
import { useAppLayoutContext } from '../AppLayout.context';
import { appLayoutNavigationRailStyles, } from './AppLayoutNavigationRail.styles';
export const AppLayoutNavigationRail = forwardRef(function AppLayoutNavigationRail(props, forwardedRef) {
    const { styles, sx, ...other } = props;
    const appLayoutContext = useAppLayoutContext();
    const { combineStyles, globalStyles } = useStyles({
        name: 'AppLayoutNavigationRail',
        styles: [appLayoutNavigationRailStyles, styles],
    });
    const transitionNodeRef = useRef(null);
    const transitionNodeHandleRef = useMergeRefs([
        transitionNodeRef,
        forwardedRef,
    ]);
    const hasNavigationRail = appLayoutContext.components.includes('navigationRail');
    if (!hasNavigationRail) {
        return null;
    }
    const navigationRailOpened = appLayoutContext.navigationMode === 'rail';
    return (_jsx(CSSTransition, { nodeRef: transitionNodeRef, in: navigationRailOpened, timeout: 550, unmountOnExit: true, children: (status) => (_jsx(FloatingTransition, { status: status, placement: 'left', origin: 'edge', pattern: 'enterExitOffScreen', sx: combineStyles('host'), ref: transitionNodeHandleRef, children: _jsx(NavigationRail, { ...other, sx: [globalStyles, combineStyles('navigationRail'), sx] }) })) }));
});
